// Import necessary Material-UI components
import { Grid, Button, TextField, Typography } from "@mui/material";
import { LoadingButtonText } from "../../common";

/**
 * ApprovalButtonsDataGrid component for displaying approval buttons
 * @param {Object} props - Component props including modal state, data, and callbacks.
 */
export function ApprovalButtonsDataGrid(props) {
  return (
    <span>
      <Grid
        container
        sx={{
          my: 2,
        }}
        spacing={1}
      >
        {/* Render Reason label if not for HOD approval */}
        {!props.approvalHod && (
          <Grid item xs={5}>
            <Typography gutterBottom>Reason:</Typography>
          </Grid>
        )}
        {/* Render TextField for entering approval/rejection reason */}
        {!props.approvalHod && (
          <Grid item xs={7}>
            <TextField
              error={props.errors && props.errors.comments && true}
              id="outlined-multiline-flexible"
              label="Approval/Rejection Reason"
              multiline
              fullWidth
              rows={4}
              value={props.comments ? props.comments : props.value.comments}
              onChange={props.handleChange}
              onKeyDown={(event) => {
                event.stopPropagation();
              }}
              helperText={
                props.errors && props.errors.comments
                  ? props.errors.comments
                  : ""
              }
            />
          </Grid>
        )}
        {/* Container for Approve and Reject buttons */}
        <Grid container item xs={12} direction="row">
          <Grid
            item
            xs={6}
            sx={{
              pr: "5px",
            }}
          >
            {/* Approve button */}
            <Button
              variant="contained"
              disabled={props.isSubmitting}
              onClick={(e) =>
                props.handleApproval({
                  e,
                  approval: true,
                  value: props.value,
                })
              }
              fullWidth
              color="success"
            >
              <LoadingButtonText loading={props.isSubmitting} text="Approve" />
            </Button>
          </Grid>
          <Grid item xs={6}>
            {/* Reject button */}
            <Button
              variant="contained"
              disabled={props.isSubmitting}
              fullWidth
              onClick={(e) =>
                props.handleApproval({
                  e,
                  approval: false,
                  value: props.value,
                })
              }
              color="error"
            >
              {/* Conditional rendering of button text or loading spinner */}

              <LoadingButtonText loading={props.isSubmitting} text="Reject" />
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </span>
  );
}
